import React from "react";

class Dropdown extends React.Component {
    constructor() {
        super();
        this.state = {
            dropdown: false
        };
        this.toggleSelf = this.toggleSelf.bind(this);
    }

    toggleSelf() {
        this.setState({
            dropdown: !this.state.dropdown
        });
    }

    render() {
        return <div className={"dropdown" + (this.state.dropdown ? " active" : "")}>
            <div className="label" onClick={this.toggleSelf}>Change currency</div>

            <div className="dropdown-items">
                {this.props.children}
            </div>
        </div>
    }
}

export default Dropdown;